import React from 'react';
import PropTypes from 'prop-types';

const GlobalNavPlaceholder = ({ disableShimmer }) => {
  const className = disableShimmer
    ? 'loading--static'
    : 'global-nav-placeholder__item--shimmer';

  return (
    <div id="global-nav-placeholder" className="global-nav-placeholder">
      <div className={`global-nav-placeholder__logo ${className}`} />
      <div className="global-nav-placeholder__link-container hide-mobile">
        <div className={`global-nav-placeholder__link ${className}`}></div>
        <div className={`global-nav-placeholder__link ${className}`}></div>
        <div className={`global-nav-placeholder__link ${className}`}></div>
        <div className={`global-nav-placeholder__link ${className}`}></div>
      </div>
      <div className="global-nav-placeholder__link-container">
        <div className={`global-nav-placeholder__link ${className}`}></div>
        <div className={`global-nav-placeholder__link ${className}`}></div>
        <div className={`global-nav-placeholder__link ${className}`}></div>
      </div>
    </div>
  );
};

GlobalNavPlaceholder.defaultProps = {
  disableShimmer: false,
};

GlobalNavPlaceholder.propTypes = {
  disableShimmer: PropTypes.bool,
};

export default GlobalNavPlaceholder;
